<template>
  <comTable :config="tableConfig" :filterForm="filterForm" ref="table">
    <template v-slot:leftBten>
      <el-button
        class="feature-item add"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addFn()"
        >新建专题列表</el-button
      >
    </template>
  </comTable>
</template>
<script>
import comTable from "@/components/firTable.vue";
export default {
  components: { comTable },
  data() {
    return {
      filterForm: [
        { prop: "id", label: "列表ID", pl: "请输入列表ID检索" },
        { prop: "title", label: "专题列表名称", pl: "请输入专题列表检索" },
        {
          prop: "display_type",
          type: "select",
          child: [
            { name: "左右切换列表", id: "0" },
            { name: "三个一行列表", id: "1" },
            { name: "单行内容列表", id: "2" },
            { name: "上下切换列表", id: "3" },
          ],
          label: "列表展示样式",
          pl: "请输入列表展示样式检索",
        },
        { prop: "tags", label: "标签", pl: "请输入标签检索" },
      ],
      tableConfig: {
        url: "subjectList",
        list: [
          { label: "列表ID", prop: "id" },
          { label: "专题列表名", prop: "title" },
          {
            label: "顶部专题图",
            prop: "prev_url",
            type: "img",
            clfn: (da) => {
              return da.prev_url
                ? `${da.prev_url}?x-oss-process=image/resize,m_fill,h_80,w_200/interlace,1`
                : "";
            },
          },
          {
            label: "列表展示样式",
            prop: "display_type",
            type: "img",
            clfn: (da) => {
              return this.tmpList[parseInt(da.display_type) - 1]
                ? this.tmpList[parseInt(da.display_type) - 1].img
                : "";
            },
          },
          {
            label: "标签",
            prop: "tags",
            type: "html",
            clfn: (da) => {
              let arr = [];
              try {
                arr = JSON.parse(da.tags);
              } catch (error) {
                console.log(error);
              }
              let str = "";
              arr.map((v) => {
                str += `<span class="tages">${v}</span>`;
              });
              return str;
            },
          },
          { label: "列表内容数", prop: "relation_subject_contents" },
          { label: "存在关联跳转", prop: "relation_jump" },
          { label: "创建时间", prop: "create_at" },
          {
            label: "操作",
            type: "tool",
            btns: [
              {
                label: "查看",
                clickFn: (da) => {
                  this.handleBtn(da, "look");
                },
              },
              {
                label: "编辑",
                clickFn: (da) => {
                  this.handleBtn(da, "edit");
                },
              },
              {
                label: "删除",
                clickFn: (da) => {
                  this.handleDel(da);
                },
              },
            ],
          },
        ],
      },
      tmpList: [
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s4.png",
          title: "左右切换列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s1.png",
          title: "三个一行列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s2.png",
          title: "单行内容列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s3.png",
          title: "上下切换列表",
        },
        {
          img: "http://static.zookingsoft.com/shiquaner-admin/pc/s5.png",
          title: "左右切换列表(红色)",
        },
      ],
    };
  },

  methods: {
    addFn() {
      this.$router.push("/art/item3-addList?type=add");
    },
    handleDel(row) {
      this.$confirm(
        `确定要删除 <span style="color:red">${row.title}</span> 吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let data = {
            id: row.id,
          };
          this.api.delSubject(data).then((res) => {
            if (!res) return;
            this.$message.success("删除成功");
            this.$refs.table.getData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleBtn(item, type) {
     let routeUrl = this.$router.resolve({
          path: "/art/item3-addList",
          query: {id:item.id,type:type}
     });
     window.open(routeUrl.href, '_blank');
      // this.$router.push(`/art/item3-addList?id=${item.id}&type=${type}`);
    },
  },
};
</script>

<style lang='scss' scoped>
.el-table__body-wrapper {
  overflow-y: auto;
}
</style>